(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-actions-queue', {
                parent: 'management',
                url: '/tab-actions-queue?search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabActionsQueue.home.title'
                },
                params: {
                    repeatable: {
                        value: '-1'
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-actions-queue/tab-actions-queues.html',
                        controller: 'TabActionsQueueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            repeatable: $stateParams.repeatable,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        }
                    }]
                }
            })
            .state('tab-actions-queue-detail', {
                parent: 'tab-actions-queue',
                url: '/tab-actions-queue/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabActionsQueue.detail.title'
                },
                params: {
                    filter: null,
                    group : null
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-actions-queue/tab-actions-queue-detail.html',
                        controller: 'TabActionsQueueDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabActionsQueue', function ($stateParams, TabActionsQueue) {
                        return TabActionsQueue.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-actions-queue.delete', {
                parent: 'tab-actions-queue',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-actions-queue/tab-actions-queue-delete-dialog.html',
                        controller: 'TabActionsQueueDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabActionsQueue', function (TabActionsQueue) {
                                return TabActionsQueue.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-actions-queue', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });


    }

})();
